import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { fmtD } from "@/lib/semanas";

export const usePublicaciones = () => useQuery({
  queryKey: ["cne", "publicaciones"],
  queryFn: async () => (await api.get("/control-semanal/cne/publicaciones")).data.items,
});

export const pubLabel = (p) => `Semana ${p.week} ${p.year} · ${fmtD(p.vigencia_inicio)} – ${fmtD(p.vigencia_fin)}`;

export function PubSelect({ pubs, value, onChange, testid }) {
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-80 bg-slate-50 border-slate-200 text-sm" data-testid={testid}><SelectValue placeholder="Selecciona una publicación" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {(pubs || []).map((p) => <SelectItem key={p.id} value={p.id}>{pubLabel(p)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function EmptyPubs() {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/70 shadow-sm p-12 text-center" data-testid="cne-empty">
      <p className="text-slate-600 font-semibold">Aún no hay publicaciones oficiales cargadas.</p>
      <p className="text-sm text-slate-400 mt-1">Actualiza desde la CNE o importa el PDF oficial de precios máximos.</p>
    </div>
  );
}

export const Var = ({ v, suffix = "" }) => {
  if (v == null) return <span className="text-slate-300">—</span>;
  const cls = v > 0 ? "text-red-600" : v < 0 ? "text-emerald-600" : "text-slate-400";
  return <span className={`font-semibold ${cls}`}>{v > 0 ? "+" : ""}{Number(v).toFixed(2)}{suffix}</span>;
};
